export const ELECTRONIC = 'electronic'
export const WRITTEN = 'written'

export const ALL_SIGNING_METHODS = [ELECTRONIC, WRITTEN] as const

export type SigningMethod = (typeof ALL_SIGNING_METHODS)[number]
